<script>
import OnlyMobile from "@js/components/DynamicComponents/OnlyMobile.vue";
import IconSearch from "@js/components/Icons/IconSearch.vue";
import {Link} from "@inertiajs/vue3";
import IconMapPoint from "@js/components/Icons/IconMapPoint.vue";
import FirstPhone from "@js/components/Sections/Links/FirstPhone.vue";
import TopBarMobileSearchInput from "@js/components/TopBar/Components/TopBarMobileSearchInput.vue";
import IconLogo from "@js/components/Icons/IconLogo.vue";
import {usePopupsControlStore} from "@js/store/PopupsControlStore.js";

export default {
    name: "MobileTopBar",
    props: {
        with_logo: false,
    },
    components: {
        IconLogo,
        TopBarMobileSearchInput,
        FirstPhone,
        IconMapPoint,
        Link,
        IconSearch,
        OnlyMobile
    },
    setup() {
        const popupStore = usePopupsControlStore()

        return {popupStore}
    }
}
</script>

<template>
    <OnlyMobile :maxSize="1024">
        <header class="mb-5">
            <template v-if="!with_logo">
                <div class="container pt-4">
                    <div class="flex items-center justify-between text-sm font-semibold">
                        <div @click.prevent="popupStore.showCitySelectPopup"
                             class="flex items-center gap-x-1 text-base">
                            <IconMapPoint class="w-4 h-4 self-center text-navHoverColor"/>
                            <span class="self-center text-sm mt-0.5">
                                 {{ popupStore.selectedCity.name }}
                            </span>
                        </div>
                        <FirstPhone/>
                    </div>
                    <div class="mt-3">
                        <TopBarMobileSearchInput/>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="container flex items-center justify-between h-[80px] mb-1">
                    <div class="-mt-5">
                        <IconLogo class="h-[40px]"/>
                    </div>
                    <div class="flex flex-col items-end justify-center text-sm font-bold -mt-5">
                        <div @click.prevent="popupStore.showCitySelectPopup"
                             class="flex items-end gap-x-1 text-base">
                            <IconMapPoint class="w-4 h-4 self-center text-navHoverColor"/>
                            <span class="self-center text-sm mt-0.5">
                                 {{ popupStore.selectedCity.name }}
                            </span>
                        </div>
                        <FirstPhone/>
                    </div>
                </div>
                <div class="container -mt-6">
                    <TopBarMobileSearchInput/>
                </div>
            </template>
        </header>
    </OnlyMobile>
</template>

<style scoped lang="scss">

</style>
